module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/events-calculator/meals/meals.component.css
// module id = ./src/app/components/calculator/calculator-item/events-calculator/meals/meals.component.css
// module chunks = main